import { API } from '../api'
import { Operator } from './interface'

export const get = async (
  filtros: Record<string, any>
): Promise<{
  conteudo: string[]
  sucesso: boolean
}> => {
  try {
    const response = await API.get<Operator>('/operadora/credencial', {
      ...filtros
    })

    return {
      conteudo: response.content,
      sucesso: response.isSuccess
    }
  } catch (error) {
    console.error('Erro ao buscar operadora:', error)
    return null
  }
}
